// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"b0049a0e","467":"87ed1984"}[chunkId] + ".chunk.js";
};